import { useEffect } from 'react';
import { 
  exraUrl,
  deepLinkView,
  deepLinkOrigin,
  deepLinkExtraParam,
  deepLinkTarget,
}                    from 'utils/constants'
import { 
  objType, 
  updateInfoType,
  userInfoType
}                    from 'types';

const useGoToVideoPage = (
  dataUpdateState:    updateInfoType,
  userInfo:           userInfoType,
  selectedApp:        objType,
  storageUpdateState: boolean,
  goToVideoOnce:      boolean,
  setGoToVideoOnce:   (val: boolean) => void,
) => {

  useEffect(() => { 

    if ( !!deepLinkTarget &&  (dataUpdateState.content || !!storageUpdateState) && !goToVideoOnce ) {
      import("functions/actions/go_to_video_page").then(func => {
        func.goToVideoPage(deepLinkTarget, exraUrl, setGoToVideoOnce, {
          view:   deepLinkView,
          origin: deepLinkOrigin,
          extraId: deepLinkExtraParam || exraUrl,
        })
      });
    }
  },[dataUpdateState, storageUpdateState, selectedApp, goToVideoOnce, setGoToVideoOnce, deepLinkTarget])



  useEffect(() => {

    if ( 
          !!deepLinkTarget.length && 
          userInfo.userLogedIn === 'false' && 
          (!localStorage.getItem('videoPage') || (!!localStorage.getItem('videoPage') || localStorage.getItem('videoPage') !== deepLinkTarget) )) {
          
          localStorage.setItem('videoPage', deepLinkTarget)

     }
  },[userInfo, deepLinkTarget])
}

export default useGoToVideoPage